export default {
  'system.title': '辰光云盛会',
  'system.sub-title': '管理端',
  'system.main.title': '辰光云盛会',
  'system.client.title': '点击这里进入您的虚拟活动',
  'login.tab.account.title': '账号登录',
  'login.tab.code.title': '验证码登录',
  'login.account': '账号',
  'login.account.placeholder': '请输入账号',
  'login.password': '密码',
  'login.password.erro': '账号或密码错误',
  'login.password.placeholder': '请输入密码',
  'login.email': '邮箱/手机号',
  'login.email.placeholder': '请输入邮箱/手机号',
  'login.email.checked.erro.info': '请输入正确的邮箱 或 手机号',
  'login.code': '验证码',
  'login.code.sent.error': '该账号不是任何一场活动的配置管理员，请确认配置管理员的邮箱/手机号。如果需要登录参加活动，请访问',
  'login.code.placeholder': '请输入验证码',
  'login.code.reget': '等待 {seconds} 秒',
  'login.code.send.success': '验证码发送成功！',
  'login.get.code': '获取验证码',
  'login.code.erro': '邮箱/手机号错误或验证码错误',
  'login': '登录',

  'menu.organizational.management': '组织管理',
  'menu.account.management': '账号管理',
  'menu.meeting.management': '活动管理',
  'menu.meeting.lead': '活动申请',
  'menu.meeting.my-meeting': '首页',
  'menu.meeting.meeting-invitation': '活动邀请',
  'menu.meeting.meeting-invitation-list': '邀请记录',
  'menu.meeting.name-list': '名单管理',
  'menu.meeting.feedback': '意见反馈',
  'menu.meeting.egg': '彩蛋记录',
  'menu.meeting.paper-survey': '试卷调查',
  'menu.meeting.sign-in': '签到记录',
  'menu.meeting.configuration': '活动配置',
  'menu.meeting.data.reporting': '数据报告',
  'menu.meeting.minutes': '活动纪要',
  'menu.meeting.invitations': '邀请参会',
  'menu.meeting.request.deletion': '请求删除',
  'menu.resources.management': '资源管理',
  'menu.resources.series': '资源系列',

  'role.super': '超级管理员',
  'role.business': '业务管理员',
  'role.configuration': '维护管理员',
  'role.default': '管理员',

  'table.organizational': '组织',
  'table.organizational.create': '创建组织',
  'table.organizational.name': '组织名称',
  'table.organizational.buy.meeting.count': '购买活动次数',
  'table.organizational.used.meeting.count': '已使用次数',
  'table.organizational.meeting.stop.timeline': '活动使用截止日期',
  'table.organizational.meeting.end.date': '活动使用截止日期',
  'table.organizational.status': '状态',
  'table.organizational.create_by': '创建人',
  'table.organizational.create_time': '创建时间',
  'table.organizational.update_by': '更新人',
  'table.organizational.update_time': '更新时间',
  'table.organizational.remark': '备注',

  'table.account': '账号',
  'table.account.create': '新建账号',
  'table.account.administrator': '管理员名称',
  'table.account.email': '管理员邮箱',
  'table.account.mobile': '管理员手机号',
  'table.account.confirm.delete.info': '确认删除该账号吗？',
  'table.account.username': '用户名',
  'table.account.avatar': '头像',
  'table.account.password': '密码',
  'table.account.login_ip': '登录ip',
  'table.account.login_date': '登录时间',
  'table.account.is_admin': '是管理员用户',
  'table.account.deleted': '已删除',
  'table.account.role_key': '角色代码',
  'table.account.mobile.phone': '手机号​',

  'table.meeting': '活动',
  'table.meeting.id': '活动ID',
  'table.meeting.create': '创建活动',
  'table.meeting.name': '活动名称',
  'table.meeting.name.required': '请选择活动',
  'table.meeting.administrator': '管理员',
  'table.meeting.status': '活动状态',
  'table.meeting.customer.name': '客户名称',
  'table.meeting.number': '活动号',
  'table.meeting.link': '活动链接',
  'table.meeting.creation.time': '创建时间',
  'table.meeting.opening.time': '系统开放时间',
  'table.meeting.shutdown.time': '系统关闭时间',
  'table.meeting.attendees.number': '参会人数',
  'table.meeting.administrator.account': '管理员账号',
  'table.meeting.confirm.delete.info': '确认删除此次活动安排',
  'table.meeting.no.start': '未开始',
  'table.meeting.on.going': '进行中',
  'table.meeting.Ended': '已结束',
  'table.meeting.managed.self': '本人管理的活动',
  'table.meeting.time.zone': '时区',
  'table.meeting.time.zone.name': '时区名称',
  'table.meeting.time.zone.show': '时区显示',
  'table.meeting.time': '活动时间',
  'table.meeting.time.start': '开始时间',
  'table.meeting.time.end': '结束时间',
  'table.meeting.time.availability': '系统开放时间',
  'table.meeting.time.open': '系统开放时间',
  'table.meeting.time.open.suggestion': '建议系统开放时间早于活动时间半小时及以上',
  'table.meeting.time.close.suggestion': '建议系统结束时间晚于活动结束时间半小时及以上',
  'table.meeting.started.cannot.deleted': '活动已经开始，无法删除',
  'table.meeting.confirm.deletion': '确认删除此次活动安排',
  'table.meeting.apply.confirm.deletion': '确认同意删除此次活动安排',
  'table.meeting.apply.confirm.deletion.user': '申请人',
  'table.meeting.started.cannot.confirm': '活动已经开始，无法配置',
  'table.meeting.type': '类型',
  'table.meeting.account.type': '类别',
  'table.meeting.title': '活动主题',
  'table.meeting.title.tip': '请输入活动主题，会自动插入到下方邀请信息正文',
  'table.meeting.bulk.mailing.list': '输入群发邮件名单',
  'table.meeting.bulk.phone.list': '群发短信名单',
  'table.meeting.cc': '抄送',
  'table.meeting.send': '发送',
  'table.meeting.mail.content': '邀请信息',
  'table.meeting.SMS.content': '短信内容',
  'table.meeting.insert.link': '插入活动链接',
  'table.meeting.insert.ID': '插入活动ID',
  'table.meeting.insert.time': '插入活动时间',
  'table.meeting.mail.save.change': '保存草稿',
  'table.meeting.radio.all': '全部活动',
  'table.meeting.radio.no.start': '未开始的活动',
  'table.meeting.radio.on.going': '进行中的活动',
  'table.meeting.radio.Ended': '已结束的活动',
  'table.meeting.review': '是否为“闭门活动”，白名单以外的参会人需要审核通过方可进入活动现场',
  'table.meeting.seat.number': '座椅数量（请选择，必选）',
  'table.meeting.only.not.started': '仅显示未开始的活动',
  'table.meeting.organizationalselect.name': '名称',
  'table.meeting.organizationalselect.attempts': '剩余次数',
  'table.meeting.organizationalselect.deadline': '截止日期',

  'table.name.lead.company': '公司名称',
  'table.name.lead.fullname': '姓名',
  'table.name.lead.position': '职务',
  'table.name.lead.phone_number': '手机',
  'table.name.lead.email': '邮箱',
  'table.name.lead.try_time': '开始时间',
  'table.name.lead.end_time': '结束时间',
  'table.name.lead.select.0': '待审核',
  'table.name.lead.select.1': '已审核',
  'table.name.lead.select.2': '已拒绝',
  'table.name.lead.command.approved': '通过',
  'table.name.lead.command.approved.info': '确认通过该申请吗？',
  'table.name.lead.command.rejected': '拒绝',
  'table.name.lead.command.rejected.info': '确认拒绝该申请吗？',

  'meeting.step.basic': '基本配置',
  'meeting.step.image': '选择场景',
  'meeting.step.image.title': '形象场景配置',
  'meeting.step.venue': '场景选择',
  'meeting.step.outfit': '服装选择',
  'meeting.step.outfit.title': '服装',
  'meeting.step.product': '3D展示（选配）',
  'meeting.step.product.title': '交互式3D展示（选配：可不选 / 可多选）',
  'meeting.step.client': '图片视频配置',
  'meeting.step.special': '特殊角色配置',
  'meeting.step.egg': '彩蛋配置（选配）',

  'meeting.scene.operate.move': 'WASD按键前后左右移动，QE上下移动',
  'meeting.scene.operate.rotate': '鼠标左键按下移动旋转视角，上下左右箭头按键旋转视角',
  'meeting.scene.image': '请选择形象配置场景',
  'meeting.scene.image.iceberg': '冰山',

  'meeting.scene.select': '请选择场景',
  'meeting.scene.seat.number': '请选择座位数量',
  'meeting.scene.show.all': '显示所有场景',
  'meeting.scene.select.tip': '请点击下方场景图标选择和预览场景',
  // 'meeting.scene.desert':'沙漠',
  'meeting.scene.desert.descr': '沙漠登录界面',
  // 'meeting.scene.haiyun.mirage':'海韵幻境',
  'meeting.scene.room.meeting': '室内活动室',
  'meeting.scene.book.meeting': '书籍活动室',
  // 'meeting.scene.underwater.meeting':'海底世界',
  // 'meeting.scene.racing.meeting':'赛车活动室',
  // 'meeting.scene.iceberg':'冰山',
  // 'meeting.scene.professional':'专业活动厅',

  // 20250825更新
  'meeting.scene.1': '炫夜舞台​',
  'meeting.scene.1-1': '超现代风格的专业活动厅​',
  'meeting.scene.2': '荒原流沙​',
  'meeting.scene.3': '商务现代',
  'meeting.scene.4': '书映流光',
  'meeting.scene.5': '海底梦幻​',
  'meeting.scene.6': '微界飞驰',
  'meeting.scene.7': '无界深蓝',

  'meeting.clothing.select': '请选择服装系列',
  'meeting.clothing.casual': '休闲系列',
  'meeting.clothing.cyber': '赛博系列',
  'meeting.clothing.business': '商务系列',
  'meeting.clothing.racing': '赛车系列',

  'meeting.client.scenarios': '功能场景',
  'meeting.client.color': '色系',
  'meeting.client.login.image': '登录页面背景图',
  'meeting.client.venue.image': '会场主图',
  'meeting.client.venue.image.big.screen': '大屏幕会场主图',
  'meeting.client.venue.image.big.screen.tip': '请上传大屏幕会场主图',
  'meeting.client.warm.video': '暖场视频',
  'meeting.client.signature.wall': '签名墙背景图片',
  'meeting.client.ai': 'AI 生成',
  'meeting.client.ai.title': '生成你的专属活动主题图',
  'meeting.client.ai.tip1': '点击后输入描述您想生成的图片',
  'meeting.client.ai.tip2': '例如：颜色 风格 场景等',
  'meeting.client.ai.tip3': '创建图片',
  'meeting.client.ai.tip4': '提示词',
  'meeting.client.ai.tip4.request': '请输入提示词',
  'meeting.client.ai.tip5': '描述您理想中的签名墙主题图',
  'meeting.client.ai.tip6': '添加 LOGO',
  'meeting.client.ai.tip7': '生成图片',
  'meeting.client.ai.tip8': '生成结果',
  'meeting.client.ai.tip9': '确认使用此图片',
  'meeting.client.ai.times': '当前会议次数已用完',

  'meeting.account.speaker': '演讲嘉宾',
  'meeting.account.administrator': '活动场控',
  'meeting.account.recording': '活动录制',
  'meeting.account.create': '添加账号',
  'meeting.account.confirm.configuration': '确认配置',
  'meeting.account.image.type': '演讲嘉宾形象',
  'meeting.account.diy.image': 'DIY形象',
  'meeting.account.customize.image': '定制形象',
  'meeting.account.NPC.role': '通用演讲嘉宾',
  'meeting.account.sign.method': '登录方式',
  'meeting.account.delete.confirm': '确认删除该用户吗?',
  'meeting.account.add.least.one': '请添加至少一个活动场控账号',
  'meeting.account.save.erro.account.unique': '账号不唯一，请确认！',

  'meeting.SMS.participated.info': '您参加的',
  'meeting.SMS.follows.info': '信息如下',
  'meeting.SMS.join.info': '点击链接入会',
  'meeting.send.success': '发送成功！',
  'meeting.has.many.email': '如有多个邮箱地址通过英文;分割',
  'meeting.has.many.sms': '如有多个短信通过英文;分割',
  'meeting.copy.all': '复制全部',
  'meeting.copy.link': '复制链接及活动ID',
  'meeting.send.invitation.email': '发送邀请邮件',
  'meeting.invitation.setting': '当前活动还未配置，去配置',

  'table.name.manage.review': '仅显示待审核名单',
  'table.name.manage.registration': '报名名单',
  'table.name.manage.registration.tip': '闭门活动的申请参会名单，开放式活动无此信息',
  'table.name.manage.special': '特殊角色',
  'table.name.manage.special.tip': '演讲嘉宾、活动场控、活动录屏名单',
  'table.name.manage.type': '角色类别',
  'table.name.manage.whitelist': '白名单',
  'table.name.manage.whitelist.tip': '闭门活动的参会白名单',
  'table.name.manage.allowed': '允许参会',
  'table.name.manage.allowed.tip': '闭门活动通过审核的参会名单，开放式活动无此信息',
  'table.name.manage.period': '报名时间',
  'table.name.manage.invited': '是否被邀请',
  'table.name.manage.review.status': '审核状态',
  'table.name.manage.invited.time': '邀请时间',

  'resource.action': '动作',
  'resource': '资源',
  'resource.name': '资源名称',
  'resource.affiliation': '所属组织',
  'resource.description': '描述',
  'resource.Cover.file.name': '封面文件名',
  'resource.resource.file.name': '资源文件名',
  'resource.preview.video': '预览视频',
  'resource.robot.coordinates': '机器人坐标',
  'resource.camera.position': '相机位置',
  'resource.hdr.file': 'hdr 文件',
  'resource.seats.Number': '座椅数量',
  'resource.clothing': '服装',
  'resource.clothing.casual': '休闲',
  'resource.clothing.cyber': '赛博',
  'resource.clothing.business': '商务',
  'resource.clothing.racing': '赛车',
  'resource.clothing.hairstyle': '发型',
  'resource.clothing.head': '头部',

  'series': '系列',
  'series.add.new': '添加新系列',
  'series.name': '系列名称',
  'series.name.required': '请输入系列名称',
  'series.preview.image': '预览图',
  'series.preview.image.required': '请上传预览图',

  'analysis.table.user.name': '用户名',
  'analysis.table.company.name': '公司名称',
  'analysis.table.login.time': '首次登录时间',
  'analysis.table.logout.time': '最后一次离开时间',
  'analysis.table.online.duration': '累计在线时长',
  'analysis.table.login_count': '登录次数',
  'analysis.table.hrn.apply.count': '形象申请次数',
  'analysis.table.hrn.success.count': '形象成功次数',
  'analysis.select.duration': '用户参会时长',
  'analysis.select.remarks': '用户发言',
  'analysis.select.questions': '用户问题',
  'analysis.select.chat': '管理员聊天记录',
  'analysis.select.product': '交互式3D展示记录',
  'analysis.select.summary': '活动纪要',

  'analysis.table.speak.count': '发言次数',
  'analysis.table.total.speak.time': '累计发言时长',
  'analysis.table.view.count': '观看次数',
  'analysis.table.view.duration': '观看累计时长',

  'goods.animation.config': '动画配置',
  'goods.animation.id': '动画编号',
  'goods.animation.name': '动画名称',
  'goods.animation.add': '添加',
  'goods.animation.model': '动画模型',

  'common.logout': `退出登录`,
  'common.button.ok': `确定`,
  'common.export': `一键导出`,
  'common.button.save': `保存`,
  'common.button.cancel': `取消`,
  'common.button.add': `添加`,
  'common.button.upload.cover.image': `点击上传封面图`,
  'common.button.upload.cover.video': `点击上传预览视频`,
  'common.button.effect.immediately': `立即生效`,
  'common.import': `导入`,
  'common.button.search': `搜索`,
  'common.data.total': `信息数量`,
  'common.data.total.unit': `条`,
  'common.data.page.size': `页码`,
  'common.operation': `操作`,
  'common.edit': `编辑`,
  'common.delete': `删除`,
  'common.confirm.delete': `确认删除`,
  'common.confirm.delete.info': `请在下方输入框输入 “<b>删除</b>” 后,点击确认按钮`,
  'common.confirm.apply.delete.info': `请在下方输入框输入 “<b>同意</b>” 后,点击确认按钮`,
  'common.input.erro.info': `输入错误`,
  'common.enter.please': `请输入`,
  'common.select.please': `请选择`,
  'common.lang.chinese': `中文`,
  'common.lang.english': `英文`,
  'common.lang.chinese.simplified': `简体中文`,
  'common.name': `姓名`,
  'common.mobile': `手机`,
  'common.email': `邮箱`,
  'common.reset': `重置`,
  'common.search': `查询`,
  'common.phone': `手机号`,
  'common.copy.link': `复制链接`,
  'common.more': `更多`,
  'common.de': `的`,
  'common.agree': `同意`,
  'common.SMS': `短信`,
  'common.import': `导入`,
  'common.mailing.list': `导入邮箱名单`,
  'common.company': `公司`,
  'common.refuse': `拒绝`,
  'common.pass': `通过`,
  'common.all': `全部`,
  'common.yes': `是`,
  'common.no': `否`,
  'common.go.back': `返回`,
  'common.next.step': `下一步`,
  'common.previous.step': `上一步`,
  'common.to': `至`,
  'common.people': `人`,
  'common.preview': `预览`,
  'common.example': `示例`,
  'common.proportion': `比例`,
  'common.label.proportion': `比例：`,
  'common.size': `尺寸`,
  'common.label.size': `尺寸为`,
  'common.file.size.less.than.25m': `比例为16:9 文件小于25MB`,
  'common.format.mp4': `MP4格式文件`,
  'common.video.size.exceed': `视频文件超过25MB，请使用第三方工具压缩后再上传`,
  'common.role': `角色`,
  'common.sex': `性别`,
  'common.sex.female': `女生`,
  'common.sex.man': `男生`,
  'common.upload': `上传`,
  'common.click.upload.image': `点击上传图片`,
  'common.click.upload.video': `点击上传视频`,
  'common.upload.tip': `正在上传，请稍后...`,
  'common.upload.loading': `正在上传`,
  'common.upload.do.not.close': `请勿关闭页面`,
  'common.upload.now': `立即上传`,
  'common.upload.resource': `请上传资源文件`,
  'common.upload.duplicate.file': `已存在同名的动画文件，请核实文件或更换文件名后再保存`,
  'common.enter.file.name': `请输入文件名`,
  'common.loading': `加载中...`,

  'common.request.name': `请输入姓名`,
  'common.request.role': `请选择角色`,
  'common.request.email': `请输入邮箱`,
  'common.request.phone': `请输入手机号`,
  'common.request.image': `请选择形象资源`,
  'common.erro.email.format': `邮箱格式错误`,
  'common.erro.phone.format': `手机号格式错误`,
  'common.save.success': `保存成功！`,
  'common.erro.save.erro': `保存失败：`,
  'common.title': `名称`,
  'common.time': `时间`,
  'common.file': `文件`,
  'common.download.excel.template': `下载EXCEL模版`,
  'common.go.home': `返回首页`,
  'common.go.home.confirm': `是否确认返回首页`,
  'common.account.save.erro.not.unique': '已存在邮箱或手机号用户，请确认！',
  'common.organizational.save.erro.not.unique': '已存在相同组织名称，请确认！',
  'common.audit': `审核`,
  'common.copy.success': `复制成功`,
  'common.copy.erro': `无法拷贝内容，请设置浏览器读取剪贴板权限`,
  'common.please.check': `请勾选`,
  'common.close': `关闭`,
  'common.agree': `已读并同意`,
  'common.hours': `时`,
  'common.minutes': `分`,
  'common.seconds': `秒`,
  'common.click.to.upload': `点击上传`,
  'common.data.sync': `活动结束后请及时点击 “数据报告” 查看数据分析，数据保留3天。`,
  'common.zoom': `缩放`,
  'common.rotate': `旋转`,
  'common.remaining': `次剩余`,
  'feedback.content': '反馈内容',
  'feedback.image': '反馈截图',
  'feedback.time': '反馈时间',
  'feedback.class': '班级',
  'egg':'彩蛋',
  'egg.title': '彩蛋名称',
  'egg.count': '彩蛋数量',
  'egg.location': '彩蛋位置',
  'egg.contact.name': '联系人',
  'egg.contact.phone': '联系电话',
  'egg.contact.address': '联系人地址',
  'egg.memo': '彩蛋领取说明',
  'survey.page.title': '投票名称',
  'survey.page.description': '投票描述',
  'survey.page.status': '投票状态',
  'survey.page.status.in_progress': '进行中',
  'survey.page.status.ended': '已结束',
  'survey.page.status.published': '已发布',
  'survey.page.question_type_1': '单选',
  'survey.page.question_type_2': '多选',
  'survey.page.fullname': '姓名',
  'survey.page.company': '班级',
  'survey.page.account': '账号',
  'survey.page.vote_time': '投票时间',
  'people_have_voted': '个人已投',
  'ticket': '票',
  'sign.in.page.username': '用户名',
  'sign.in.page.name': '姓名',
  'sign.in.page.class': '班级',
  'sign.in.page.signinTime': '签到时间',
  'sign.in.page.signinInstructions': '签到说明',
  'sign.in.page.signinDuration': '签到时长',
  'sign.in.page.createdTime': '创建时间',
}


